const { SHIPMENT_TYPE_ALL_TYPES } = require('../../shipment')
const { joinRemarks, aggregateQuantitiesBySku, updateCountsFromSkuQuantities } = require('../utils')

function createSalesReturn ({ mainApi, logger, batches }) {
  return async function salesReturn (params) {
    if (!params) {
      const err = new Error('salesReturn: params parameter is required')
      err.status = 400
      throw err
    }
    const payload = Array.isArray(params) ? params[0] : params
    if (typeof payload.reference_number === 'undefined') {
      const err = new Error('salesReturn: reference_number parameter is required')
      err.status = 400
      throw err
    }
    let originalShipment
    try {
      originalShipment = await mainApi.shipment.getShipmentByNumber({ shipmentNumber: payload.reference_number })
    } catch (err) {
      const error = new Error(`Shipment not found: ${payload.reference_number}: ${err}`)
      error.status = 404
      throw error
    }
    if (!originalShipment) {
      const err = new Error(`Shipment not found: ${payload.reference_number}`)
      err.status = 404
      throw err
    }

    const entryItems = (payload.items && payload.items[0] && payload.items[0].items) || []
    const unifiedRemarks = joinRemarks(entryItems.map(item => item.remarks))

    await batches.fromSalesReturn(entryItems)

    const salesReturnQuantities = aggregateQuantitiesBySku(
      entryItems,
      (item) => Number(item.grn_quantity) || 0,
      {
        getBatchEntries: (item) => {
          if (!item || !item.batch_number) return []
          return [{
            batchNumber: item.batch_number,
            quantity: Number(item.grn_quantity) || 0
          }]
        }
      }
    )
    const counts = updateCountsFromSkuQuantities(originalShipment.counts, salesReturnQuantities)
    try {
      const count = await mainApi.shipment.listLastMileDeliveries({
        filters: { shipment_id: originalShipment.id, status: ['received'] },
        onlyCount: true,
        addSnapshotsData: false,
        deliveryType: SHIPMENT_TYPE_ALL_TYPES
      })
      if (count && count > 0) {
        return
      }
    } catch (_) {
      if (logger && logger.warn) {
        logger.warn({ code: 'received-snapshot-already-exists', orderId: originalShipment.orderId })
      }
    }

    const snapshotData = {
      ...originalShipment,
      doCheckSent: false,
      counts,
      comment: unifiedRemarks,
      status: 'received'
    }

    console.log('Creating sales return snapshot with data:', {
      orderId: snapshotData.orderId,
      status: snapshotData.status,
      comment: snapshotData.comment,
      countsKeys: Object.keys(snapshotData.counts || {})
    })
    await mainApi.shipment.createSnapshot(snapshotData)
  }
}

module.exports = createSalesReturn
